<template>
   
    <ul class="nav_breadcrumbs">
        <li><router-link to="/modules/administration">{{lang.LBL_DEFAULT_ADMIN}}</router-link></li>
        <li><router-link to="/modules/reportauths/edit">{{lang.LBL_NEW_REPORT_AUTHS}}</router-link></li>
        <li><router-link to="/modules/reportauths">{{lang.LBL_VIEW_REPORT_AUTHS}}</router-link></li>
    </ul>
     

</template>
<script>
import lang from "@/views/modules/ReportAuths/language/en";
export default {
    name: "breadcrumbs",
    data() {
        return {
            lang:[],
        }
     },
     mounted() {
        this.lang = lang;
    },
     
}
</script>
